import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async get ({ commit, dispatch }, id) {
    try {
      const { data } = await directus.getUser(id)
      commit('setAttr', {
        name: 'model',
        value: data
      })
      dispatch('set')

      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
